import { render, staticRenderFns } from "./add-bargain-first.vue?vue&type=template&id=bbd54ec4&scoped=true&"
import script from "./add-bargain-first.vue?vue&type=script&lang=ts&"
export * from "./add-bargain-first.vue?vue&type=script&lang=ts&"
import style0 from "./add-bargain-first.vue?vue&type=style&index=0&lang=stylus&module=true&"
import style1 from "./add-bargain-first.vue?vue&type=style&index=1&id=bbd54ec4&lang=stylus&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bbd54ec4",
  null
  
)

export default component.exports